<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>

      <yo-button
        class="mg-r-15"
        label="AJOUTER"
        tooltip="Ajouter des conditionnements variante"
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        (onClick)="openDialogAjoutCondiVariantes()">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>
<dx-data-grid
  [dataSource]="udpConditionnementVariantesList"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(250)"
  width="100%"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>
  <dxi-column dataField="id" caption="Actions" [width]="100"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>
  <dxi-column dataField="conditionnementVariante" caption="Conditionnement variante" [width]="100"
              [filterOperations]="['contains']"
              [allowFiltering]="true"
              cellTemplate="conditionnementVarianteCellTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" (onClick)="openDeleteObject(cell.row.data)"
                    [disabled]="isDisabledDeleteBtn(cell.row.data)"
                    iconClass="fa fa-trash"
                    tooltip="Supprimer le conditionnement variant de la liste de l'unité de production"
    ></yo-button>
  </div>

  <div *dxTemplate="let cell of 'conditionnementVarianteCellTemplate'">
    {{cell.row.data.conditionnementVariante.conditionnement.libelle}} {{cell.row.data.conditionnementVariante.variante.libelle}}
  </div>
</dx-data-grid>

<yo-dialog-ajout-conditionnement></yo-dialog-ajout-conditionnement>
